import { HBL_PA_RESOURCES } from "./data.cnst";

export const DEFAULT_ROUTE_PRIORITY = [
  // Events
  {
    resource: HBL_PA_RESOURCES.LOCO_EVENTS,
    path: "/dashboard",
  },
  {
    resource: HBL_PA_RESOURCES.STATION_EVENTS,
    path: "/dashboard/station-events",
  },

  // Health
  {
    resource: HBL_PA_RESOURCES.LOCO_HEALTH,
    path: "/health/loco-health",
  },
  {
    resource: HBL_PA_RESOURCES.STATION_HEALTH,
    path: "/health/station-health",
  },

  // Trip Summary
  {
    resource: HBL_PA_RESOURCES.TRIP_SUMMARY,
    path: "/find-trips",
  },

  // Reports -> Loco Health
  {
    resource: HBL_PA_RESOURCES.LOCO_READER_EFFICIENCY,
    path: "/report/loco-health/reader-efficiency",
    name: "Reader Efficiency"
  },
  {
    resource: HBL_PA_RESOURCES.LOCO_RF_ISSUES,
    path: "/report/loco-health/rf-issues-loco",
    name: "Radio RF Issues"
  },
  {
    resource: HBL_PA_RESOURCES.LOCO_CRASH_LOGS,
    path: "/report/loco-health/crash-logs",
    name: "Crash"
  },
  {
    resource: HBL_PA_RESOURCES.LOCO_CARD_STATUS,
    path: "/report/loco-health/card-status",
    name: "Card Status"
  },
  {
    resource: HBL_PA_RESOURCES.LOCO_BRAKE_VC_LOGS_MONITORING,
    path: "/report/loco-health/brake-failure",
    name: "Brake Failure"
  },
  {
    resource: HBL_PA_RESOURCES.LOCO_CARD_DIAGNOSTICS,
    path: "/report/loco-health/card-diagnostics",
  },
  {
    resource: HBL_PA_RESOURCES.LOCO_DMI_HEALTH_MONITORING,
    path: "/report/loco-health/dmi-health-monitoring",
    name: "DMI Health"
  },
  {
    resource: HBL_PA_RESOURCES.LOCO_SPEEDOMETER_HEALTH_MONITORING,
    path: "/report/loco-health/speedometer-health-monitoring",
    name: "Speedometer"
  },
  {
    resource: HBL_PA_RESOURCES.LOCO_RADIO_PARAMETERS_MONITORING,
    path: "/report/loco-health/radio-parameters-monitoring",
  },
  {
    resource: HBL_PA_RESOURCES.LOCO_CHECKSUM_CHANGE,
    path: "/report/loco-health/checksum-change-report",
  },
  {
    resource: HBL_PA_RESOURCES.LOCO_CAB_RFID_READER,
    path: "/report/loco-health/cab-rfid-reader",
    name: "Cab & RFID Reader"
  },

  // Reports -> Station Health
  {
    resource: HBL_PA_RESOURCES.STATION_EIGW_FAILURE,
    path: "/report/station-health/eigw-failure",
    name: "EIGW"
  },
  {
    resource: HBL_PA_RESOURCES.STATION_S2S_LINK_FAILURE,
    path: "/report/station-health/s2s-link-failure",
    name: "S2S Link"
  },
  {
    resource: HBL_PA_RESOURCES.STATION_RF_ISSUES,
    path: "/report/station-health/rf-issues-station",
    name: "Radio RF Issues"
  },
  {
    resource: HBL_PA_RESOURCES.STATION_CARD_STATUS,
    path: "/report/station-health/card-status",
    name: "Card Status"
  },
  {
    resource: HBL_PA_RESOURCES.STATION_CRASH_LOGS,
    path: "/report/station-health/crash-logs",
  },
  {
    resource: HBL_PA_RESOURCES.STATION_CARD_DIAGNOSTICS,
    path: "/report/station-health/card-diagnostics",
  },
  {
    resource: HBL_PA_RESOURCES.STATION_RADIO_PARAMETERS_MONITORING,
    path: "/report/station-health/radio-parameters-monitoring",
  },
  {
    resource: HBL_PA_RESOURCES.STATION_CHECKSUM_CHANGE,
    path: "/report/station-health/checksum-change-report",
  },
  {
    resource: HBL_PA_RESOURCES.STATION_FIU,
    path: "/report/station-health/fiu",
    name: "FIU Failure"
  },
  {
    resource: HBL_PA_RESOURCES.STATION_SYSTEM_FAILURE,
    path: "/report/station-health/system-failure",
    name: "System Failure"
  },
  {
    resource: HBL_PA_RESOURCES.STATION_CHANGEOVER_OF_CARDS,
    path: "/report/station-health/changeover-of-cards",
  },
  {
    resource: HBL_PA_RESOURCES.STATION_RIU,
    path: "/report/station-health/riu",
    name: "RIU"
  },
  {
    resource: HBL_PA_RESOURCES.STATION_SIGNAL_ASPECT_BLANKING,
    path: "/report/station-health/signal-aspect-blanking",
    name: "Signal Raw Aspect"
  },
  {
    resource: HBL_PA_RESOURCES.STATION_MONITORING_BOOT_LOGS,
    path: "/report/station-health/monitoring-boot-logs",
  },

  // Reports -> Events
  {
    resource: HBL_PA_RESOURCES.EVENTS_TAG_MISSING,
    path: "/report/events/tag-missing",
  },
  {
    resource: HBL_PA_RESOURCES.EVENTS_TAG_MISSING_NEW,
    path: "/report/events/tag-new",
  },
  {
    resource: HBL_PA_RESOURCES.EVENTS_UNWANTED_BRAKING,
    path: "/report/events/unwanted-braking",
  },
  {
    resource: HBL_PA_RESOURCES.EVENTS_SIGNAL_BLANKING,
    path: "/report/events/signal-blanking",
  },

  // Station Metadata
  {
    resource: HBL_PA_RESOURCES.STATION_METADATA,
    path: "/station-metadata",
  },

  // User Management
  {
    resource: HBL_PA_RESOURCES.USERMGMT,
    path: "/usermgmt",
  },
];